import { render, staticRenderFns } from "./MatchTransactionsIcon.vue?vue&type=template&id=54f17a48&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54f17a48')) {
      api.createRecord('54f17a48', component.options)
    } else {
      api.rerender('54f17a48', component.options)
    }
    module.hot.accept("./MatchTransactionsIcon.vue?vue&type=template&id=54f17a48&functional=true&", function () {
      api.rerender('54f17a48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/MatchTransactionsIcon.vue"
export default component.exports